import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { OcOrderStatusSummaryModel } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import {
    ApiResultModel,
    getOcSubscribers,
} from "@WhiteCap/Store/Service/OsnSubscriptionsServices/OrderCompleteSubscribersService";

export interface SubscriptionsDashboardApiParameter extends ApiParameter {
    customerId?: string;
    onError?: (message: string) => void;
    onSuccess?: (data: OcOrderStatusSummaryModel) => void;
}
type HandlerType = CustomApiHandler<SubscriptionsDashboardApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/BeginOcSubscribersDataLoad",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getOcSubscribers(props.apiParameter.customerId);
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter.onSuccess) {
            const data = {
                properties: result.result.properties,
                subscribedEmails: result.result.subscribedEmails,
                count: result.result.ocOrderStatusSummary?.count,
            };
            props.apiParameter.onSuccess(data);
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/OcSubscribersDataLoadError",
        });
        return false;
    }
};

export const DispatchCompleteOcSubscribersDataLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/CompleteOcSubscribersDataLoad",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteOcSubscribersDataLoad];

const loadOcSubscribers = createHandlerChainRunner(chain, "LoadOcSubscribers");
export default loadOcSubscribers;
